import { rateLimitStatusesQuery } from '#pplx/frontend/apps/ask/user-settings/rateLimitStatusesQuery.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
// This hook observes the shared /status cache (same key as
// useRateLimits) and returns its free_queries sub-field.
export const useFreeQueries = ({ reason, enabled: callerEnabled = true, }) => {
    const isUserLoggedIn = useIsUserLoggedIn();
    const { data, isLoading } = useQuery(rateLimitStatusesQuery.getOptions({ reason }, {}, { enabled: isUserLoggedIn && callerEnabled }));
    return { data: data?.free_queries, isLoading };
};
// Returns the new remaining count, or null when the cache can't be locally
// decremented (obfuscated/missing → invalidate to refetch).
export const useDecrementFreeQueries = () => {
    const queryClient = useQueryClient();
    return useCallback(() => {
        const queryKey = rateLimitStatusesQuery.getKey({});
        const statuses = queryClient.getQueryData(queryKey);
        const free_queries = statuses?.free_queries;
        if (!statuses || free_queries?.remaining_detail.kind !== 'exact') {
            queryClient.invalidateQueries({ queryKey });
            return null;
        }
        const newRemaining = Math.max(0, free_queries.remaining_detail.remaining - 1);
        queryClient.setQueryData(queryKey, {
            ...statuses,
            free_queries: {
                available: newRemaining > 0,
                remaining_detail: { kind: 'exact', remaining: newRemaining },
            },
        });
        return newRemaining;
    }, [queryClient]);
};
//# sourceMappingURL=useFreeQueries.js.map